<template>
  <template v-if="user">
    <div class="card-outlined p-4">
      <router-link
        to="/account/change-name"
      >
        <div class="flex items-center justify-between border-gray-300 border-b px-2 mb-5">
          <div>
            <div class="form-label">{{ t('word.name') }}</div>
            <div class="font-semibold">{{ user.name ?? t('word.none') }}</div>
          </div>
          <div>
            <base-svg-icon class="w-6" :path="mdiChevronRight" />
          </div>
        </div>
      </router-link>
      <router-link
        to="/account/change-nickname"
      >
        <div class="flex items-center justify-between border-gray-300 border-b px-2 mb-5">
          <div>
            <div class="form-label">{{ t('word.nickname') }}</div>
            <div class="font-semibold">{{ user.nickname ?? t('word.none') }}</div>
          </div>
          <div>
            <base-svg-icon class="w-6" :path="mdiChevronRight" />
          </div>
        </div>
      </router-link>
      <router-link
        to="/account/change-email"
      >
        <div class="flex items-center justify-between border-gray-300 border-b px-2 mb-5">
          <div>
            <div class="form-label">{{ t('word.email') }}</div>
            <div class="font-semibold">{{ user.email ?? t('word.none') }}</div>
          </div>
          <div>
            <base-svg-icon class="w-6" :path="mdiChevronRight" />
          </div>
        </div>
      </router-link>
      <router-link
        to="/account/change-password"
      >
        <div class="flex items-center justify-between border-gray-300 border-b px-2 mb-5">
          <div>
            <div class="form-label">{{ t('word.password') }}</div>
            <div class="font-semibold">**********</div>
          </div>
          <div>
            <base-svg-icon class="w-6" :path="mdiChevronRight" />
          </div>
        </div>
      </router-link>
      <router-link
        to="/account/change-mode"
      >
        <div v-if="is_well_labo" class="flex items-center justify-between border-gray-300 border-b px-2 mb-5">
          <div>
            <div class="form-label">{{ t('display_mode.title') }}</div>
            <div class="font-semibold">{{ user.display_mode ? t(`display_mode.${user.display_mode}`) : t('display_mode.default') }}</div>
          </div>
          <div>
            <base-svg-icon class="w-6" :path="mdiChevronRight" />
          </div>
        </div>
      </router-link>
    </div>
  </template>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { mdiChevronRight, mdiCheckCircleOutline } from '@mdi/js'
import { UserAttributes } from '@/types/models/user'
import { RoleAttributes } from '@/types/models/role'
import { useStore } from '@/store/index'

import BaseSvgIcon from '@/components/BaseSvgIcon.vue'

export default defineComponent({
  props: {
    user: {
      type: Object as PropType<UserAttributes | undefined>,
      'default': () => (undefined),
    }
  },
  components: { BaseSvgIcon },
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const is_well_labo = ref(false)
    is_well_labo.value = !!store.state.user.user.roles.find((element:RoleAttributes) => element.slug === 'well_labo')

    return {
      t,
      mdiChevronRight,
      mdiCheckCircleOutline,
      is_well_labo
    }
  },
})
</script>
